<template>
    <div>
        <!-- <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert> -->
        <core-error-alerts :errors="errorMsgList"></core-error-alerts>

        <transition name="fade-fast" mode="out-in">
        
            <busy-spinner v-if="loading" key="loadingTrue" inner-class="my-4" text="Loading..."></busy-spinner>

            <div v-else key="loadingFalse">
                
                <p class="text-muted font-size-70 font-italic">Submitted by <span class="text-dark font-weight-500">{{ replyData.submitted_by_name }}</span> on {{ formatDateTime(replyData.submitted_on) }}</p>
                
                <div class="d-flex align-items-start">
                    <BaseS3FileDownloadButtonGroup
                        :fileData="replyData.active_files"
                        :vertical="true"
                        bundleDownloadLocation="below"
                        :buttonProps="{
                            block: true,
                            buttonVariant: 'subtle-primary',
                            hideFilesize: false,
                        }"
                        style="max-width: 70%;"
                    />
                    <!-- <file-download-badge
                        v-if="replyData.upload"
                        :file-data="replyData.upload"
                        button-variant="light-primary"
                    ></file-download-badge> -->
                    <div 
                        v-if="replyData.comment"
                        class="ml-4"
                    >
                        <p class="mb-2 spl-attribute-labels font-size-70">Comment:</p>
                        <p>{{ replyData.comment }}</p>
                    </div>
                </div>

                <!-- <pre>{{ replyData }}</pre> -->
            </div>
        
        </transition>

    </div>
</template>

<script>
import { suppliosApi } from '../../js/api-service';
import { errorHandling } from '../../js/custom-vue-mixins';
//import { DateTime } from 'luxon';
import { FormatDateTimeLocal } from '../../js/filters-helpers';
import BaseS3FileDownloadButtonGroup from '../s3_files/BaseS3FileDownloadButtonGroup.vue';

export default {
    name: 'DocRequestReplyViewer',
    components: {BaseS3FileDownloadButtonGroup},
    mixins: [
        errorHandling,
    ],
    props: {
        replyId: {
            type: [String, Number],
            required: true,
        }
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            loading: true,  // set to true for this, so it always starts in loading mode
            replyData: {},  // put here from API
        }
    },
    computed: {

    },
    mounted: function() {
        this.getReply();
    },
    methods: {
        // use apiErrorHandler(error, extraMsg, localMsg) from mixin - if localMsg = true, will put error message in this.errorHandlingMessage (string)
        getReply: function() {
            this.loading = true;
            return suppliosApi.docRequestReply.retrieve(this.replyId)
                .then(response => {
                    this.replyData = response.data;
                    return true;
                })
                .catch(error => {
                    this.apiErrorHandler(error, null, true);
                    return false;
                })
                .then(success => {
                    this.loading = false; 
                    return success;
                });
        },
        formatDateTime: function(value) {
            return FormatDateTimeLocal(value);
        }
    }
}
</script>

<style>

</style>